module.exports = __webpack_public_path__ + "img/ic_notchange.dd99949d.svg";